export default __webpack_public_path__ + "static/media/close-filter.eb9be343.svg";